import { render, staticRenderFns } from "./hsyztDetail.vue?vue&type=template&id=5b656674&scoped=true"
import script from "./hsyztDetail.vue?vue&type=script&lang=js"
export * from "./hsyztDetail.vue?vue&type=script&lang=js"
import style0 from "./hsyztDetail.vue?vue&type=style&index=0&id=5b656674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b656674",
  null
  
)

export default component.exports